import type { SVGProps } from 'react'
const SvgSyPaperFail = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillRule="evenodd"
			d="M7.979 2.012A4.49 4.49 0 0 0 3.5 6.49v10.85c0 2.581 2.146 4.525 4.69 4.525h7.882c2.477 0 4.479-2.06 4.479-4.525V8.037a.75.75 0 0 0-.21-.517l-5.064-5.278a.75.75 0 0 0-.54-.23zm0 1.5h6.437l4.635 4.828v9c0 1.655-1.335 3.025-2.979 3.025H8.19C6.381 20.365 5 19.111 5 17.34V6.49a2.967 2.967 0 0 1 2.979-2.978"
			clipRule="evenodd"
		/>
		<path d="M14.475 2a.75.75 0 0 0-.75.75v2.91a3.335 3.335 0 0 0 3.316 3.324c.659.002 1.324.002 1.838.002h.637c.161 0 .184.004.33-.006a.75.75 0 0 0 .699-.796.75.75 0 0 0-.797-.7c.1-.006-.08.002-.238.002h-.631c-.512 0-1.178 0-1.836-.002a1.81 1.81 0 0 1-1.818-1.824V2.75a.75.75 0 0 0-.75-.75" />
		<path
			fillRule="evenodd"
			d="M10.64 10.651a.75.75 0 1 0-1.06 1.061l1.203 1.203-1.203 1.202a.75.75 0 0 0 1.06 1.061l1.204-1.203 1.202 1.203a.75.75 0 0 0 1.06-1.06l-1.202-1.203 1.203-1.203a.75.75 0 0 0-1.06-1.06l-1.203 1.202z"
			clipRule="evenodd"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyPaperFail
